<template>
    <div class="joinUs">
      <mHead :classType="'light'" :showSearch="true"></mHead>
      <div class="main">
           <div class="title">加入我们</div>
            <div class="img">
                <img v-for="(item, index) in imgListTop" :src="item.url" :key="index + 'top'" alt="">
            </div>
            <div class="jobDiv">
                <div class="jobName">
                    <div class="item" @click="showBox=!showBox">
                        <p class="name">{{jobName}} <em :class="'arrow ' + (showBox?'up':'dowm')"></em></p>
                        <p class="time">更新于{{time | formatDate('yyyy.MM.dd')}}</p>
                        <div class="jobBox" v-show="showBox">
                            <div class="item " v-for="item in jobList" :key="item.sort" @click.stop="changeItem(item)">
                                <p class="name">{{item.name}}</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div :class="'item ' + (item.sort == jobId?'on':'')" v-for="item in jobList" :key="item.sort" @click="changeItem(item)">
                        <p class="name">{{item.name}}</p>
                        <p class="time">{{item.sort == jobId?item.time:'' | formatDate('yyyy.MM.dd')}}</p>
                    </div> -->
                </div>
                <div class="content" v-html="content">

                </div>
            </div>
      </div>
      <mBottom :classType="'light'"></mBottom>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    components:{ mHead, mBottom },
    data() {
        return {
            imgListTop: [{
                // url: require('@/assets/img/joinUs.png')
            }],
            imgListBottom: [],
            jobImg: {
                url: ''
            },
            addressList: [],
            tableData: [],
            typeList: [],
            jobId: 0,
            jobName: '',
            time: '',
            content: '',
            jobList: [
                
            ],
            selectTypeId: -1,
            selectAddressId: -1,
            showBox: false
        }
    },
    computed: mapState({
    // 映射 this.count 为 store.state.count
       
        // swiper() {
        //     return this.$refs.mySwiper.swiper
        // },
    }),
    mounted(){
        this.getList();
        this.statistics();
    },
    methods: {
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '加入我们'} ).then(response =>{
              
            })
        },
        changeItem(item){
            this.showBox = false;
            this.jobId = item.sort;
            this.jobName = item.name;
            this.time = item.time;
            this.content = item.desc;
        },
        showList() {

        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=10' ).then(response =>{
                if(response.status == 200){
                    let list = response.body || []
                    if(list.length > 0){
                        list.map(item => {
                            if(item.keyName == 'imgListTop'){
                                let urlList = item.content.split(',')
                                let heightList = item.keyDesc.split(',')
                                urlList.map((em,ind) => {
                                    this.imgListTop.push({ height: heightList[ind], url: em})
                                })
                            } else if(item.keyName == 'jobList'){
                                this.jobList = JSON.parse(item.content || '[]');
                                if(this.jobList.length > 0) {
                                    this.jobId = this.jobList[0].sort
                                    this.jobName = this.jobList[0].name
                                    this.time = this.jobList[0].time
                                    this.content = this.jobList[0].desc;
                                }
                            }
                        })
                    }
                } else {
                    this.$message.error(response.message?response.message:'error');
                }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .joinUs {
        background: #ffffff;
        .main {
            margin: poToRem(54) 0 0;
            padding: poToRem(20);
            .title {
                font-size: poToRem(24);
                padding-bottom: poToRem(20);
                text-align: left;
            }
            .img {
                width: 100%;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .jobDiv {
                width: 100%;
                
                .jobName {
                    width: 100%;
                    padding-top: poToRem(40);
                    .item {
                        text-align: left;
                        margin-bottom: 24px;
                        position: relative;
                        .name {
                            font-size: poToRem(24);
                            color: rgba(0, 0, 0, 1);
                            .arrow {
                                display: inline-block;
                                position: relative;
                                &.dowm {
                                    border-top: poToRem(3) solid #000000;
                                    border-left: poToRem(3) solid #000000;
                                    height: poToRem(8);
                                    width: poToRem(8);
                                    margin-left: poToRem(8);
                                    transform: rotate(225deg) translateY(poToRem(4));
                                }
                                &.up {
                                    border-top: poToRem(3) solid #000000;
                                    border-left: poToRem(3) solid #000000;
                                    height: poToRem(8);
                                    width: poToRem(8);
                                    margin-left: poToRem(16);
                                    transform: rotate(45deg) translateY(poToRem(4));
                                }
                                
                            }
                        }
                        .time {
                            font-size: poToRem(12);
                            margin-top: poToRem(4);
                        }
                        .jobBox {
                            position: absolute;
                            left: 0;
                            top: poToRem(34);
                            background: #fff;
                            box-shadow: 0 0 poToRem(6) #e9e8e8;
                            padding: poToRem(14) poToRem(24);
                            min-width: poToRem(180);
                            // border: 1px solid #999999;
                            .name {
                                font-size: poToRem(18);
                            }
                        }
                    }
                }
                .content {
                    width: 100%;
                    text-align: left;
                    box-sizing: border-box;
                    
                }
            }
        }
    }
</style>
<style lang="scss">
@import "@/assets/style/base.scss";
   .joinUs {
        .main {
            .jobDiv {
                .content {
                    ol {
                        padding-left: poToRem(20);
                        margin: poToRem(10) 0 poToRem(20);
                        li {
                            font-size: poToRem(16);
                            color: rgba(0,0,0,0.6);
                        }
                    }
                    p {
                        font-size: poToRem(16);
                        color: rgba(0,0,0,0.6);
                    }
                    h3,h4,h5,h2,h1 {
                        margin: 0;
                    }
                    h1 {
                        font-size: poToRem(40);
                    }
                    h2 {
                        font-size: poToRem(30);
                    }
                    h3 {
                        font-size: poToRem(24);
                    }
                    h4 {
                        font-size: poToRem(20);
                    }
                    h5 {
                        font-size: poToRem(16);
                    }
                }
            }
        }
   }
</style>





// WEBPACK FOOTER //
// src/modules/view/joinUs/mobile.vue